/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

/* eslint-disable no-useless-escape */
import { getStoreConfig } from '@/auth/api';
import { COOKIE_LIFETIME } from '@/auth/configs/cookieConfigs';

export const getCookie = (cookieName: string) => {
  const cookies = document.cookie.split(';');
  let foundValue;

  cookies.forEach((cookie) => {
    const [name, value] = cookie.trim().split('=');
    if (name === cookieName) {
      foundValue = decodeURIComponent(value);
    }
  });

  return foundValue;
};

export const deleteCookie = (cookieName: string) => {
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`;
};

export const getCookiesLifetime = async () => {
  try {
    const storeConfigString = sessionStorage.getItem('storeConfig');
    const cachedStoreConfig = storeConfigString
      ? JSON.parse(storeConfigString)
      : {};

    let accessTokenLifeTime = cachedStoreConfig.customerAccessTokenLifetime;

    if (!accessTokenLifeTime) {
      const storeConfig = await getStoreConfig();

      sessionStorage.setItem('storeConfig', JSON.stringify(storeConfig));

      accessTokenLifeTime =
        storeConfig?.customerAccessTokenLifetime || COOKIE_LIFETIME;
    }

    return `Max-Age=${accessTokenLifeTime}`;
  } catch (error) {
    console.error('getCookiesLifetime() Error:', error);
    return `Max-Age=${COOKIE_LIFETIME}`;
  }
};
